import { Mail, MapPin } from "lucide-react";
import { site } from "../content/site";
import { handleAnchorClick } from "../lib/scroll";
import { Logo } from "./Logo";

const productLinks = [
  { label: "Features", href: "#features", testid: "footer-features-link" },
  { label: "How It Works", href: "#how-it-works", testid: "footer-how-it-works-link" },
  { label: "Security", href: "#security", testid: "footer-security-link" },
  { label: "FAQs", href: "#faqs", testid: "footer-faqs-link" },
];

export const Footer = () => (
  <footer className="border-t border-gray-200 bg-white" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-gray-600" data-testid="footer-tagline">
            {site.brand.tagline}
          </p>
          <a
            href={`mailto:${site.contact.email}`}
            data-testid="footer-email-link"
            className="mt-5 inline-flex items-center gap-2 rounded-sm text-sm font-medium text-brand transition-colors duration-200 hover:text-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            {site.contact.email}
          </a>
          <p
            className="mt-3 flex items-center gap-2 text-sm font-medium text-gray-600"
            data-testid="footer-address"
          >
            <MapPin className="h-4 w-4 text-brand" aria-hidden="true" />
            {site.contact.address}
          </p>
        </div>

        <nav aria-label="Product links">
          <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-400">Product</h3>
          <ul className="mt-4 space-y-3">
            {productLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={link.testid}
                  onClick={(e) => handleAnchorClick(e, link.href)}
                  className="rounded-sm text-sm text-gray-600 transition-colors duration-200 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Company links">
          <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-400">Company</h3>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                href="/contact-us"
                data-testid="footer-contact-link"
                className="rounded-sm text-sm text-gray-600 transition-colors duration-200 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
              >
                Contact
              </a>
            </li>
            <li>
              <a
                href="/privacy-policy"
                data-testid="footer-privacy-link"
                className="rounded-sm text-sm text-gray-600 transition-colors duration-200 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="/terms-and-conditions"
                data-testid="footer-terms-link"
                className="rounded-sm text-sm text-gray-600 transition-colors duration-200 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
              >
                Terms &amp; Conditions
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="mt-14 border-t border-gray-200 pt-6">
        <p className="text-xs text-gray-500" data-testid="footer-copyright">
          © 2026 Banga Pay. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
